/* 🤖 this file was generated by svg-to-ts */
export const mgcIconHoeCuteFi: {
  name: 'hoe-cute-fi';
  data: string;
} = {
  name: 'hoe-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.024 3.104c-1.689.305-3.132 1.534-3.718 3.167a4.798 4.798 0 0 0-.273 1.653c0 .632.067 1.043.262 1.617.298.876 1.042 2.857 1.178 3.137.373.767 1.157 1.225 1.96 1.145.656-.066.923-.253 2.258-1.577l1.072-1.063 4.468 4.467c3.483 3.481 4.509 4.484 4.649 4.547a1 1 0 0 0 1.319-.524 1.088 1.088 0 0 0-.018-.835c-.038-.076-2.078-2.149-4.533-4.607l-4.465-4.468 1.061-1.072c1.299-1.311 1.458-1.53 1.554-2.138.138-.869-.313-1.679-1.16-2.085-.602-.288-3.283-1.251-3.747-1.346-.484-.098-1.373-.107-1.867-.018"/></svg>`
};
